import { createFileRoute } from "@tanstack/react-router";
import {
  IntersectionPage,
  buildIntersectionHead,
} from "@/components/IntersectionPage";
import { INTERSECTION_CONFIGS } from "@/lib/intersectionData";

const CONFIG = INTERSECTION_CONFIGS.find((c) => c.slug === "hvac-seo-castle-rock")!;

export const Route = createFileRoute("/hvac-seo-castle-rock")({
  head: () => buildIntersectionHead(CONFIG),
  component: () => <IntersectionPage config={CONFIG} />,
});
